/**
 * Story search box inside the "add story" modal. Lives entirely within the
 * modal content, which is re-rendered fresh every time the modal opens, so it
 * never needs to be re-initialized on turbo-stream navigation. Reaches the
 * message form's Trix editor via an outlet instead of a shared ancestor
 * controller.
 *
 * Example: { data: {
 *   controller: "forms--chat-story-search",
 *   "forms--chat-story-search-url-value": "/conversations/1/story_options",
 *   "forms--chat-story-search-forms--chat-message-form-outlet": "#message_form"
 * } }
 */
import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash-es";

export default class extends Controller {
  static targets = ["storySearchInput"];
  static values = { url: String };
  static outlets = ["chat-message-form"];

  connect() {
    this.debouncedUpdateStoryOptions = debounce(this.updateStoryOptions, 400);
  }

  onStoryAttachmentClick(e) {
    e.preventDefault();
    const sgid = e.currentTarget.dataset["sgid"];

    if (sgid && this.hasChatMessageFormOutlet) {
      this.chatMessageFormOutlet.attachStory(sgid);
    }
  }

  handleStorySearchInputEvent(e) {
    this.debouncedUpdateStoryOptions();
  }

  updateStoryOptions() {
    const search_query = this.storySearchInputTarget.value || "";

    fetch(`${this.urlValue}?` + new URLSearchParams({ search: search_query }), {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
